import { displayImportedText, displayMethod } from '../services/displayLabels';
import React from 'react';

export function BiaMethodDetails({ measurement, showIssue = true }) {
  const m = measurement || {};
  const unified = m.formulaVersion === 'GedipBioImp2-6109-unified-1';
  return <>
    {showIssue && m.processingIssue && <p role="status">Elaborazione da completare: {displayImportedText(m.processingIssue)} I dati originali sono conservati.</p>}
    <details className="bia-source-notes">
      <summary>Metodo e provenienza</summary>
      <p>{unified ? 'Metodo di calcolo Sibilla · Elaborazione unica per dati importati e nuove misure.' : m.processingIssue ? 'Elaborazione non disponibile.' : 'Metodo registrato: ' + displayMethod(m.formulaVersion)}</p>
      <p>Origine: {m.patientContextVersion?.startsWith('gedip-') ? 'archivio importato' : 'acquisizione Sibilla'}.</p>
      <p>Frequenze: {m.acquisitionProfile === 'multifrequency' ? '5 / 50 / 100 kHz' : m.acquisitionProfile === 'classic' ? '50 / 100 kHz' : 'profilo non registrato'}.</p>
      {unified && <p>Età di calcolo: {m.calculationAgeYears} anni, calcolati come differenza tra gli anni di calendario. La corporatura conservata con la misura determina la formula. Le eventuali elaborazioni precedenti restano archiviate.</p>}
    </details>
  </>;
}
